
<text-input
  :id="id"
  ref="input"
  v-model="localValue"
  class="currency-input"
  type="decimal"
  :symbol="currencySymbol"
  :label="label"
  :required="required"
  :disabled="disabled"
>
  <slot />
</text-input>
